import { BDCPProduct } from './product.model';

export class BDCPProductsListResponse {

    public type: 'BROTHER' | 'NON_BROTHER';
    public products: BDCPProduct[];
}
